<template>
    <div class="main-cn">
        <div class="main-bd mg20 pro-visible">
            <el-tabs v-model="activeTab" @tab-click="handleClick">
                <!--<el-tab-pane label="上传日志" name="zj_log"></el-tab-pane>-->
                <el-tab-pane label="下载日志" name="down_log">
                    <!--<el-tabs v-model="activeTab" @tab-click="handleClick">-->
                    <!--<el-tab-pane label="资源中心" name="resource_center"></el-tab-pane>-->
                    <!--<el-tab-pane label="集体备课" name="beike"></el-tab-pane>-->
                    <!--<el-tab-pane label="实验演示" name="exp_show"></el-tab-pane>-->
                    <!--</el-tabs>-->
                </el-tab-pane>
            </el-tabs>
            <el-form ref="form" :inline="true" :model="searcherModel" class="demo-form-inline">
                <el-form-item label="学段/学科筛选">
                    <el-select size="small" v-model="searcherModel.xd" placeholder="请选择">
                        <el-option v-for="(item, key) in xd" :key="key" :label="item" :value="key">
                        </el-option>
                    </el-select>
                    <el-select size="small" v-model="searcherModel.chid" placeholder="请选择">
                        <el-option v-for="(item, key) in subjects" :key="item.subject_id" :label="item.subject_name"
                                   :value="item.subject_id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="时间筛选">
                    <el-date-picker
                            size="small"
                            type="daterange"
                            unlink-panels
                            v-model="searcherModel.time"
                            range-separator="至"
                            value-format="yyyy-MM-dd"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="高级筛选(不支持模糊搜索)">
                    <el-input placeholder="请输入内容" v-model="searcherModel.advance_filter_content"
                              class="input-with-select">
                        <el-select style="width: 110px" v-model="searcherModel.advance_filter_type" slot="prepend"
                                   placeholder="请选择">
                            <el-option v-for="(item, key) in advance_filters" :key="key" :label="item" :value="key">
                            </el-option>
                        </el-select>
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" type="success" @click="exportLog">导出Excel(最多导出10000条)</el-button>
                    <el-button type="primary" size="small" @click="submitSearch" icon="el-icon-search">搜索</el-button>
                    <el-button size="small" @click="resetForm()">重置</el-button>
                </el-form-item>
            </el-form>
            <!--组卷日志-->
            <div v-if="activeTab=='down_log'">共消耗<span style="color: red">{{coin_sum}}</span>个学币</div>
            <el-table :data="list" style="width: 100%" v-loading="loading"
                      class="scrollbar tabTopBorder order-tab-list" :key="activeTab">
                <el-table-column label="资料ID" prop="itemid"></el-table-column>
                <el-table-column label="资料标题" prop="subject"></el-table-column>
                <el-table-column label="学段学科">
                    <template slot-scope="scope">
                        {{xd[scope.row.xueduanid]}}/
                        <span v-if="scope.row.chid" v-for="item in subjects">
                                <span v-if="item.subject_id == scope.row.chid ">
                                    {{item.subject_name}}
                                </span>
                            </span>
                    </template>
                </el-table-column>
                <el-table-column label="类型" prop="type"></el-table-column>
                <el-table-column label="学币" prop="coin"></el-table-column>
                <el-table-column label="下载时间" prop="down_time"></el-table-column>
                <el-table-column label="真实姓名" prop="real_name"></el-table-column>
                <el-table-column label="下载人" prop="username"></el-table-column>
                <el-table-column label="所属学校" prop="school_name"></el-table-column>
                <el-table-column label="来源类型" prop="source_type"></el-table-column>
                <el-table-column label="下载IP" prop="downip"></el-table-column>
            </el-table>
            <el-row v-if="linkPage">
                <pagination :linkPage="linkPage"></pagination>
            </el-row>
        </div>
    </div>
</template>

<script>
    import Pagination from "~/widgets/Pagination.vue";
    import Log from "~/services/log";
    import Params from "~/config/params";
    import Function from "~/common/functions";



    export default {
        components: {
            Pagination,
        },
        data() {
            return {
                activeTab: 'down_log',
                xd: {
                    1: '小学',
                    2: '初中',
                    3: '高中',
                },
                advance_filters: {
                    0: '请选中',
                    1: '下载人',
                    2: '资料ID',
                    3: '学校名称',
                    4: '学校ID',
                },
                subjects: [],
                types: {
                    0: "普",
                    1: "精",
                    2: "特",
                    3: "资源包",
                },
                searcherModel: {
                    xd: '',
                    chid: '',
                    paperfrom: '',
                    usertype: '',
                    advance_filter_type: '',
                    advance_filter_content: '',
                    time: [],
                },
                list: [],
                coin_sum: '',
                point_sum: '',
                loading: true,
                // 分页信息
                linkPage: null
            };
        },
        watch: {
            activeTab(d, v) {
                this.activeTab = d;
            }
        },

        // 监听路由参数更新执行分页请求
        beforeRouteUpdate: function (to, from, next) {
            let params = this.searcherModel;
            params['page'] = to.query["page"];
            params['perPage'] = to.query["perPage"];
            this.initData(params);
        },
        created: function () {
            this.initData();
            this.subjects = Params.getSubjects();
        },
        methods: {
            down_count(params = {}) {
                Log.zj_down_count_point(params).then(res => {
                    this.coin_sum = res.data['coin_sum'];
                    this.point_sum = res.data['point_sum'];
                });
            },
            handleClick(tab) {
                this.searcherModel = {};
                this.list = [];
                this.loading = true;
                if (this.activeTab == 'work_log') {
                    this.advance_filters = this.work_advance_filters;
                }
                this.initData();
            },
            initData(params = {}) {

                let fetch = '';
                if (this.activeTab == 'down_log') {
                    fetch = Log.jb_down_log(params);
                }
                fetch.then(res => {
                    this.loading = false;
                    this.list = res.data;
                    if(res.data.length>0){
                        this.coin_sum = _.first(res.data)['coins'];
                    }
                    this.linkPage = res._meta;
                });
            },
            // 筛选查询
            submitSearch() {
                // loading 动画
                this.loading = true;
                let params = {
                    xd: this.searcherModel.xd,
                    chid: this.searcherModel.chid,
                    time: this.searcherModel.time,
                    advance_filter_type: this.searcherModel.advance_filter_type,
                    advance_filter_content: this.searcherModel.advance_filter_content,
                }
                this.initData(params);
            },
            // 重置筛选表单
            resetForm() {
                this.searcherModel = _.clone(_.extend(this.searcherModel, {
                    xd: '',
                    chid: '',
                    time: [],
                    advance_filter_type:'',
                    advance_filter_content: '',
                }));
                this.initData();
            },
            exportLog() {
                let params = [];
                let obj = this.searcherModel;
                Object.keys(obj).forEach((key) => {
                    if (key === 'time') {
                        return;
                    }
                    let value = obj[key];
                    if (!value) {
                        return;
                    }
                    params.push([key, encodeURIComponent(value)].join('='))
                })
                if (params.length == 0 && this.searcherModel.time.length == 0) {
                    this.$message({
                        message: "请先选择过滤条件,再进行导出",
                        type: "error"
                    });
                    return false;
                }
                Function.exportFile('https://scrm.21cnjy.net/product/jb/export', this.searcherModel);
                return false;
            },
        }
    };
</script>



// WEBPACK FOOTER //
// src/views/log/jb.vue